import { plugin as intercomPlugin } from '@/services/vue-intercom'
import { createPinia } from 'pinia'
import PortalVue from 'portal-vue'
import { createApp } from 'vue'

import { initMeasures } from '@/performance/measure'

import App from './App.vue'
import './assets/darwin-icon-font/style.css'
import './assets/styles/global/variables/colorsV3.scss'
import './assets/styles/index.scss'
import clickOutsideDirective from './directives/click-outside'
import inputAutoBlurDirective from './directives/input-auto-blur'
import loadingDirective from './directives/loading'
import './registerServiceWorker'
import router from './router'
import { INTERCOM_APP_ID } from './services/config'
import { observeInvalidIntercomIFrames } from './services/intercom'
import { setupSentry } from './services/sentry'
import { mark } from '@/performance/mark'
import { APP_INIT } from '@/performance/keys'
import { configureAppCompat } from './compat'

configureAppCompat()

mark(APP_INIT)

if (INTERCOM_APP_ID) {
  observeInvalidIntercomIFrames()
}

const app = createApp(App)
app.config.compilerOptions.whitespace = 'preserve'

setupSentry(app, router)

app.use(PortalVue)
app.use(intercomPlugin, { appId: INTERCOM_APP_ID })
app.directive('click-outside', clickOutsideDirective)
app.directive('input-auto-blur', inputAutoBlurDirective)
app.directive('loading', loadingDirective)

const pinia = createPinia()
app.use(pinia)
app.use(router)

app.mount('#app-container')

document.documentElement.setAttribute(
  'data-theme',
  window.localStorage.getItem('appearance') ?? 'light',
)

initMeasures()
